export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Sobre <span className="text-blue-600">Nosotros</span>
            </h2>
            <div className="w-20 h-1 bg-blue-600 mb-8"></div>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              <strong>JDJ Ingeniería & Arquitectura</strong> es una empresa peruana especializada en el desarrollo de proyectos de <strong>ingeniería eléctrica</strong>, <strong>arquitectura</strong> e <strong>infraestructura</strong>. Nuestro equipo combina experiencia técnica y visión estratégica para ofrecer soluciones eficientes, seguras y sostenibles.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Trabajamos con empresas, instituciones y desarrolladores que requieren proyectos ejecutados con altos estándares técnicos en <strong>Lima</strong> y todo el <strong>Perú</strong>.
            </p>
            <div className="mt-10 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">15+</div>
                <div className="text-sm text-gray-600">Años de Experiencia</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">200+</div>
                <div className="text-sm text-gray-600">Proyectos Completados</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">100%</div>
                <div className="text-sm text-gray-600">Clientes Satisfechos</div>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f30bb1c469ad341b509d24bdfec68171.jpg"
                alt="Equipo JDJ Ingeniería"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-8 rounded-xl shadow-xl max-w-xs">
              <p className="text-sm font-semibold">
                "Soluciones integrales de ingeniería con los más altos estándares técnicos"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}